/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Box } from "@material-ui/core";
import _ from "lodash";
import { useSelector } from "react-redux";
import { nFormatter } from "lib/utils";
import ScenarioCard from "../Scenario_Card/CompetitorScenarioCard";
import CompetitorDialog from "../competitors_scenario_dialog/CompetitorDialog";

const useStyles = makeStyles(() => ({
  emptyScenarioContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "bold",
    userSelect: "none",
  },
  emptyScenarioText: {
    margin: "auto",
  },
  cardMainContainer: {
    margin: "20px 30px 20px 30px",
    border: "2px dotted #a6a6a6",
    borderRadius: "5px",
    backgroundColor: "#fafafa",
    display: "flex",
    height: "160px",
    "&:hover": {
      boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.1)",
    },
  },
}));
export default function CompetitorScenarioCardComponent({
  baseCompetitorScenarioData,
  competitorData,
  setCompetitorsData,
  setBaseCompetitorKpis,
}) {
  const classes = useStyles();
  const [showPopup, setShowPopup] = useState(false);
  const [totalsImpacted, setTotalsImpacted] = useState({});
  const [totalsMarketShare, setTotalsMarketShare] = useState({});
  const filtersSlice = useSelector((state) => state.filters);
  const companiesSlice = useSelector((state) => state.companies);

  const calcTotals = () => {
    let haveData = false;
    let baseCompetitorKpisFiltered =
      competitorData.scenarioData?.impacted_base_scenario;
    if (
      filtersSlice.filters.category !== "" &&
      filtersSlice.filters.category !== undefined
    ) {
      baseCompetitorKpisFiltered = _.filter(
        competitorData.scenarioData?.impacted_base_scenario,
        (row) => {
          return _.includes(
            _.map(filtersSlice.filters.category, "id"),
            row.category_id
          );
        }
      );
    }
    const totals = _.reduce(
      baseCompetitorKpisFiltered,
      (prev, curr) => {
        haveData = true;
        return {
          margin: prev.margin + curr.margin,
          salesOut: prev.salesOut + curr.sales,
          sellOut: prev.sellOut + curr.units,
          baseMargin: prev.baseMargin + curr.margin_base,
          baseSalesOut: prev.baseSalesOut + curr.sales_base,
          baseSellOut: prev.baseSellOut + curr.units_base,
        };
      },
      {
        margin: 0,
        salesOut: 0,
        sellOut: 0,
        baseMargin: 0,
        baseSalesOut: 0,
        baseSellOut: 0,
      }
    );
    return haveData ? totals : null;
  };

  const calcTotalsMarketShare = () => {
    let haveData = false;
    let totals = {};
    let marketShareValuesFiltered =
      competitorData.scenarioData?.market_share_values;
    const ourCompany = _.find(companiesSlice, { is_client_company: true });
    if (
      filtersSlice.filters.category !== "" &&
      filtersSlice.filters.category !== undefined
    ) {
      marketShareValuesFiltered = _.filter(
        competitorData.scenarioData?.market_share_values,
        (row) => {
          return _.includes(
            _.map(filtersSlice.filters.category, "id"),
            row.category_id
          );
        }
      );
      // Initialize accumulator for totals
      const aggregatedTotals = _.reduce(
        marketShareValuesFiltered,
        (acc, item) => {
          // Check if it's our company's data
          const isOurCompany = item.company_id === ourCompany.id;

          // Accumulate global totals for base and modified sales
          acc.salesBaseFilteredTotal += item.sales_base;
          acc.salesModifiedFilteredTotal += item.sales_modified;

          // If it's our company's data, accumulate for specific market share totals
          if (isOurCompany) {
            acc.ourCompanySalesBase += item.sales_base;
            acc.ourCompanySalesModified += item.sales_modified;
            acc.ourCompanyBasePrice += item.price_base * item.units_base;
            acc.ourCompanyPriceModified +=
              item.price_modified * item.units_modified;
          }

          return acc;
        },
        {
          salesBaseFilteredTotal: 0,
          salesModifiedFilteredTotal: 0,
          ourCompanySalesBase: 0,
          ourCompanySalesModified: 0,
          ourCompanyBasePrice: 0,
          ourCompanyPriceModified: 0,
        }
      );

      // Calculate totals using the accumulated values
      totals.baseMarketShare =
        (aggregatedTotals.ourCompanySalesBase /
          aggregatedTotals.salesBaseFilteredTotal) *
        100;
      totals.marketShare =
        (aggregatedTotals.ourCompanySalesModified /
          aggregatedTotals.salesModifiedFilteredTotal) *
        100;
      totals.basePrice = aggregatedTotals.ourCompanyBasePrice;
      totals.priceModified = aggregatedTotals.ourCompanyPriceModified;
    } else {
      // Initialize accumulator for totals
      totals = _.reduce(
        marketShareValuesFiltered,
        (acc, item) => {
          // Check if it's our company's data
          const isOurCompany = item.company_id === ourCompany.id;
          // If it's our company's data, accumulate for specific market share totals
          if (isOurCompany) {
            acc.baseMarketShare += item.ms_base;
            acc.marketShare += item.ms_modified;
            acc.basePrice += item.price_base * item.units_base;
            acc.priceModified += item.price_modified * item.units_modified;
          }

          return acc;
        },
        {
          baseMarketShare: 0,
          marketShare: 0,
          basePrice: 0,
          priceModified: 0,
        }
      );
    }

    haveData = true;

    if (haveData) {
      return totals;
    }
    return null;
  };

  const handleDialogOpen = () => {
    setShowPopup(true);
  };

  const handleDialogClose = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    setTotalsImpacted(calcTotals());
    setTotalsMarketShare(calcTotalsMarketShare());
  }, []);

  useEffect(() => {
    setTotalsImpacted(calcTotals());
    setTotalsMarketShare(calcTotalsMarketShare());
  }, [filtersSlice.filters, competitorData]);

  let cardContent = (
    <Box className={classes.emptyScenarioContainer} onClick={handleDialogOpen}>
      <Box className={classes.emptyScenarioText}>
        <Typography variant="h5">+</Typography>
        <Typography variant="body1">
          Create competitors scenario to affect yours
        </Typography>
      </Box>
    </Box>
  );
  if (competitorData.scenarioData) {
    if (totalsImpacted === null) {
      cardContent = (
        <Box
          className={classes.emptyScenarioContainer}
          onClick={handleDialogOpen}
        >
          <Typography variant="body1" className={classes.emptyScenarioText}>
            Selected category is not within the scope of the cycle, please
            choose another one
          </Typography>
        </Box>
      );
    } else {
      const showedValues = {
        marketShare: _.round(totalsMarketShare.marketShare, 2),
        salesOut:
          totalsImpacted.salesOut && nFormatter(totalsImpacted.salesOut),
        sellOut: totalsImpacted.sellOut && nFormatter(totalsImpacted.sellOut),
        margin: totalsImpacted.margin && nFormatter(totalsImpacted.margin),
      };
      const showedPercentages = {
        salesOut: _.round(
          (100 *
            (totalsImpacted.salesOut -
              (competitorData.scenarioData
                ? totalsImpacted.baseSalesOut
                : 0))) /
            totalsImpacted.baseSalesOut,
          2
        ),

        sellOut: _.round(
          (100 *
            (totalsImpacted.sellOut -
              (competitorData.scenarioData ? totalsImpacted.baseSellOut : 0))) /
            totalsImpacted.baseSellOut,
          2
        ),
        margin: _.round(
          (100 *
            (totalsImpacted.margin -
              (competitorData.scenarioData ? totalsImpacted.baseMargin : 0))) /
            totalsImpacted.baseMargin,
          2
        ),
        marketShare: _.round(
          totalsMarketShare.marketShare - totalsMarketShare.baseMarketShare,
          2
        ),
        price: _.round(
          (100 * (totalsImpacted.price - totalsImpacted.basePrice)) /
            totalsImpacted.basePrice
        ),
      };
      cardContent = (
        <ScenarioCard
          name={competitorData.scenarioData?.name}
          cycleLabel={competitorData.scenarioData?.cycleLabel}
          cycleType={competitorData.scenarioData?.cycleType}
          ownerLabel={competitorData.scenarioData?.ownerLabel}
          pricePercentageModification={
            competitorData.scenarioData?.pricePercentageModification
          }
          comment={competitorData.scenarioData?.comment}
          handleScenarioClick={handleDialogOpen}
          customCompetitorData={competitorData.scenarioData}
          customCompetitorSliderData={competitorData.slidersData}
          marketShare={`${showedValues.marketShare}%`}
          percentageMarketShare={showedPercentages.marketShare}
          salesOut={showedValues.salesOut}
          percentageSalesOut={showedPercentages.salesOut}
          sellOut={showedValues.sellOut}
          percentageSellOut={showedPercentages.sellOut}
          margin={showedValues.margin}
          percentageMargin={showedPercentages.margin}
        />
      );
    }
  }

  return (
    <Box className={classes.cardMainContainer}>
      <CompetitorDialog
        baseCompetitorScenarioData={baseCompetitorScenarioData}
        isActive={showPopup}
        competitorData={competitorData}
        setCompetitorsData={setCompetitorsData}
        handleDialogClose={handleDialogClose}
        setBaseCompetitorKpis={setBaseCompetitorKpis}
      />
      {cardContent}
    </Box>
  );
}
